// Catalogo minimo de paises para el selector de contacto.
// Paraguay es el default. Se puede ampliar agregando entradas aca.

export type Pais = {
  code: string;   // ISO corto (PY, AR, ...)
  nombre: string; // Nombre visible
  dial: string;   // Codigo de marcacion con + (ej. "+595")
};

export const PAISES: Pais[] = [
  { code: 'PY', nombre: 'Paraguay', dial: '+595' },
  { code: 'AR', nombre: 'Argentina', dial: '+54' },
  { code: 'BR', nombre: 'Brasil', dial: '+55' },
  { code: 'UY', nombre: 'Uruguay', dial: '+598' },
  { code: 'BO', nombre: 'Bolivia', dial: '+591' },
  { code: 'CL', nombre: 'Chile', dial: '+56' },
  { code: 'PE', nombre: 'Peru', dial: '+51' },
  { code: 'CO', nombre: 'Colombia', dial: '+57' },
  { code: 'US', nombre: 'Estados Unidos', dial: '+1' },
  { code: 'ES', nombre: 'Espana', dial: '+34' },
];

// Paraguay por defecto.
export const PAIS_DEFAULT: Pais = PAISES[0];

export function paisPorDial(dial: string): Pais | undefined {
  return PAISES.find((p) => p.dial === dial);
}
